import { declare } from "csi/def/ActionFactory";
import MessageDialog from "csi/widget/MessageDialog";
import Purge from "./Purge";
import _StateMachineStateActions from "./_StateMachineStateActions";
import { Context } from "csi/def/Context";
import { C8Node } from "csi/typings";

const PurgeAllPreviousRevisions = declare("PurgeAllPreviousRevisions", Purge, {
	m_tag: "PurgeAllPreviousRevisions",
	confirmAction: MessageDialog.BUTTON_PURGE,

	/** PurgeAllPreviousRevisions action is not in map unless explicitly enabled */
	_hasStateAccess(ctx: Context, master: C8Node, revision: C8Node): boolean {
		const actions = _StateMachineStateActions[master.StateMachine];
		const stateActions = actions?.[revision.State];
		return stateActions?.[this.m_tag] == true;
	},
});
export = PurgeAllPreviousRevisions;